import toast from '@/ext/toast'

export function useToast() {
  return toast;
}
